import React from 'react';
import ReactDOM from 'react-dom';

import { HomepageSearch } from '/components/homepage-search/HomepageSearch';

(() => {
    const homepageSearch = document.querySelector('[data-homepage-search]');

    if (homepageSearch) {
        ReactDOM.render(
            <HomepageSearch />, 
            homepageSearch,
        );  
    }
})();
